import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Flower2, Activity, Footprints, Users, Gift } from 'lucide-react';
const services = [{
  icon: Flower2,
  title: '精油按摩',
  subtitle: 'Aromatherapy Massage',
  desc: '新加坡幸福缘精油按摩服务，融合天然植物精油与专业按摩手法，通过芳香疗法舒缓身心，促进血液循环，有效缓解压力与疲劳，让您达到深层放松的极致体验。'
}, {
  icon: Sparkles,
  title: '泰式按摩',
  subtitle: 'Thai Massage',
  desc: '正宗传统泰式按摩，由经验丰富的专业技师运用拉伸、按压等手法，帮助您释放全身压力，舒展筋骨，恢复身体活力，是新加坡最受欢迎的按摩项目之一。'
}, {
  icon: Activity,
  title: '深层组织按摩',
  subtitle: 'Deep Tissue',
  desc: '专业深层组织按摩，针对肌肉深层组织进行精准按压，有效缓解长期积累的疲劳与肌肉酸痛，特别适合工作压力大、久坐办公的高压人群，是新加坡白领首选的减压方式。'
}, {
  icon: Footprints,
  title: '足部按摩',
  subtitle: 'Foot Reflexology',
  desc: '专业足部反射区按摩，通过刺激足底穴位，促进全身血液循环，调节内分泌，有效改善睡眠质量，缓解头痛与疲劳，是养生保健的理想选择。'
}, {
  icon: Users,
  title: '伴游服务',
  subtitle: 'Companion Services',
  desc: '新加坡幸福缘高端伴游服务，为您提供气质出众、谈吐优雅的专业社交伴侣，适用于商务宴请、社交活动等各类场合，让您尽享尊贵体验。'
}, {
  icon: Gift,
  title: '定制服务',
  subtitle: 'Custom Package',
  desc: '幸福缘提供个性化定制服务，根据您的具体需求与偏好，量身打造专属的放松体验方案，支持上门按摩、酒店按摩等多种服务方式，全方位满足您的需求。'
}];
export function Services() {
  return <section id="services" className="py-24 bg-[#faf7f2]" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="text-center mb-16" data-id="element-186">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-187">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-188">
              尊贵服务
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium mb-2" data-id="element-189">
              Our Premium Services
            </p>
            <p className="max-w-3xl mx-auto text-gray-600 leading-relaxed mt-6 text-lg" data-id="element-190">
              新加坡幸福缘提供全方位的专业按摩与伴游服务，涵盖精油按摩、泰式按摩、深层组织按摩、足部按摩等多种项目。无论您是寻求减压放松，还是需要专业的上门按摩与酒店按摩服务，我们经验丰富的技师团队都能为您量身定制最适合的方案，让您在新加坡享受最顶级的身心放松体验。
            </p>
            <div className="w-24 h-1 bg-[#c9a96e] mx-auto mt-6" data-id="element-191" />
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-192">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-white p-8 rounded-sm shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#c9a96e]/30" data-id="element-193">
              <div className="w-14 h-14 bg-[#1a1a2e] rounded-full flex items-center justify-center mb-6 group-hover:bg-[#c9a96e] transition-colors duration-300" data-id="element-194">
                <service.icon className="text-[#c9a96e] group-hover:text-white transition-colors duration-300" size={28} data-id="element-195" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#1a1a2e] mb-1 group-hover:text-[#c9a96e] transition-colors" data-id="element-196">
                {service.title}
              </h3>
              <p className="text-sm text-gray-500 uppercase tracking-wide mb-4 font-medium" data-id="element-197">
                {service.subtitle}
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-198">{service.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}